/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface ISchwerpunktDisplayModel {
  name?: null | string;
}
export class SchwerpunktDisplayModel extends BaseModel implements ISchwerpunktDisplayModel {
  name?: null | string;
}
class BaseSchwerpunktDisplayModelFormGroup extends FormGroup {
  private static _instance: SchwerpunktDisplayModelFormGroup;
  
  public static get Instance(): SchwerpunktDisplayModelFormGroup {
    this._instance = new SchwerpunktDisplayModelFormGroup({
      name: new FormControl(null),
    });

    return this._instance;
  }
}


export class SchwerpunktDisplayModelFormGroup extends BaseSchwerpunktDisplayModelFormGroup {
  public get Name(): FormControl {
    return this.controls["name"] as FormControl;
  }
  

}

export module SchwerpunktDisplayModelForm
  {
    export class FormFields
    {
      static _name: string = "name";
    }
  }

